<script>
	// visual components
	import Bushes from "../../components/Bushes.svelte";

	// business logic
	import { isPortraitScreen } from '../../js/model/stores';
	import { pageOffset, universalScroll, toggleUniversalToPageScroll } from '../../js/model/stores';
	import { animateElement } from '../../js/utils/animate';

	let _button;
	let portrait;

	let unsubscribeFromPageOffset = () => {};

	export let route;

	let animation = (value) => {
		animateElement(value, _button, (currentPageOffset) => {

			// The button has to appear earlier in portrait mode
			if (currentPageOffset > (window.innerHeight / (portrait ? 4 : 2))) {
				_button.style.opacity = 1;
				unsubscribeFromPageOffset();
			}
		});
	};

	let prepareScene = () => {
		if (!_button) {
			requestAnimationFrame(prepareScene);
			return;
		}

		isPortraitScreen.subscribe((state) => {
			portrait = state;
		});
		unsubscribeFromPageOffset = pageOffset.subscribe(animation);
	};

	prepareScene();
</script>

<style>
	a {
		opacity: 0;
		transition: opacity .5s;
		z-index: 5;
		text-align: center;
		pointer-events: all;
		text-decoration: none;
		position: absolute;
		left: 50%;
		top: 60%;
		transform: translateX(-50%);
	}

	.portrait > a {
		top: 48%;
	}

	.link-support {
		height: auto;
		z-index: 5;
		margin: 0 auto;
	}
</style>

<Bushes>
	{#if route === 'home'}
		<a href="#participate" bind:this={_button} id="participate_button">
			<div class="link-support cta">Werde<br>Unterstützer.</div>
		</a>
	{/if}
</Bushes>
